// import mapboxgl from '!mapbox-gl'

class PinMaps { 
    // Reinitialise Mapbox
    init = (properties) => {
        mapboxgl.accessToken = properties.accessToken;

        let map = new mapboxgl.Map({
            container: 'map',
            style: properties.style,
            center: properties.center,
            zoom: properties.zoom
        });

    
        window.addEventListener('resize', () => {
            map.resize(); // Tell Mapbox to update its rendering
        });
        
        document.querySelector('.map-overlay').addEventListener('click', () => {
            document.querySelectorAll('.map-entry').forEach(elem => {
                elem.classList.add('hidden');
                document.querySelector('.map-overlay').classList.add('hidden');

                map.flyTo({
                    center: properties.center,
           
                    essential: true, // Adjust the zoom level as needed
                    zoom: properties.zoom,
                    speed: 1.2, // Optional: Adjust the animation speed
                    curve: 1.42 // Optional: Adjust the animation curve (higher = more dramatic)
                });
                
            });
        });
      

        document.querySelectorAll('.map-entry').forEach(elem => {
            console.log(elem);
            
            map.on('load', function () {
                // Define the SVG as a string
                let svg = '<svg width="30" height="43" viewBox="0 0 58 83" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="29" cy="29" r="29" fill="' + elem.dataset.colour + '"/><path d="M28.9124 82.7335L55.1004 35.2002H2.90039L28.9124 82.7335Z" fill="' + elem.dataset.colour + '"/></svg>';

                // Convert the SVG to a Blob URL
                let svgBlob = new Blob([svg], { type: 'image/svg+xml' });
                let url = URL.createObjectURL(svgBlob);
            
                let img = new Image();
                img.onload = () => {
                    // Add the image directly to Mapbox
                    map.addImage('custom-marker_' + elem.dataset.id, img);
            
                    // Add Source
                    map.addSource('pin-source_' + elem.dataset.id, {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: [
                                {
                                    type: 'Feature',
                                    geometry: {
                                        type: 'Point',
                                        coordinates: [elem.dataset.lng, elem.dataset.lat] // Replace with longitude and latitude of the pin
                                    },
                                    properties: {
                                        title: ''
                                    }
                                }
                            ]
                        }
                    });
            
                    // Add Pin with custom SVG marker
                    map.addLayer({
                        id: 'pin-layer_' + elem.dataset.id,
                        type: 'symbol',
                        source: 'pin-source_' + elem.dataset.id,
                        layout: {
                            'icon-image': 'custom-marker_' + elem.dataset.id, // Use the custom marker
                            'icon-size': 1,                // Adjust size as needed
                            'icon-anchor': 'bottom',      // Pin aligns at its bottom
                            'text-field': ['get', 'title'], // Optional text label
                            'text-offset': [0, -2],       // Offset text above the pin
                            'text-anchor': 'top'
                        },
                        paint: {
                            'text-color': '#000'         // Optional text colour
                        }
                    });


                     // Add click event listener
                    map.on('click', 'pin-layer_' + elem.dataset.id, function (e) {
                        const coordinates = e.features[0].geometry.coordinates.slice();
                        const properties = e.features[0].properties;

                        // Example JavaScript action
                        console.log('Pin clicked:', properties);
                       
                        map.flyTo({
                            center: coordinates,
                            essential: true, // Adjust the zoom level as needed
                            zoom: 7,
                            speed: 1.2, // Optional: Adjust the animation speed
                            curve: 1.42 // Optional: Adjust the animation curve (higher = more dramatic)
                        });

                       document.querySelector('#map-entry-' + elem.dataset.id).classList.remove('hidden');
                       document.querySelector('.map-overlay').classList.remove('hidden');
                   
                    });

                    // Change cursor to pointer when hovering over a pin
                    map.on('mouseenter', 'pin-layer_' + elem.dataset.id , () => {
                        map.getCanvas().style.cursor = 'pointer';
                    });

                    map.on('mouseleave', 'pin-layer_' + elem.dataset.id, () => {
                        map.getCanvas().style.cursor = '';
                    });
                        
                    // Revoke the Blob URL after it's used
                    URL.revokeObjectURL(url);
                };
            
                img.src = url; // Set the image source to the Blob URL
            });
        });
    }
}

export default PinMaps;